import React from 'react';
import { Container, Row, Col, Card, Table } from 'react-bootstrap';
import { MdTrendingUp, MdTrendingDown, MdAnalytics } from 'react-icons/md';

const Analytics: React.FC = () => {
  const analyticsData = [
    { metric: 'Page Views', value: '45,678', growth: 12.5, trend: 'up' },
    { metric: 'Unique Visitors', value: '23,456', growth: 8.3, trend: 'up' },
    { metric: 'Bounce Rate', value: '34.2%', growth: -5.2, trend: 'down' },
    { metric: 'Conversion Rate', value: '3.8%', growth: 15.7, trend: 'up' },
    { metric: 'Avg. Session Duration', value: '4m 32s', growth: 2.1, trend: 'up' },
    { metric: 'Revenue', value: '$12,543', growth: 18.9, trend: 'up' }
  ];

  return (
    <Container fluid className="py-4">
      <div className="page-header mb-4">
        <h2><MdAnalytics className="me-2" />Data Insights Dashboard</h2>
        <p className="text-muted">Comprehensive analytics and insights for your business</p>
      </div>

      <Row className="mb-4">
        {analyticsData.map((item, index) => (
          <Col md={4} lg={2} key={index} className="mb-3">
            <Card className="h-100">
              <Card.Body className="text-center">
                <h6 className="card-title text-muted">{item.metric}</h6>
                <h4 className="mb-2">{item.value}</h4>
                <small className={`${item.trend === 'up' ? 'text-success' : 'text-danger'}`}>
                  {item.trend === 'up' ? <MdTrendingUp /> : <MdTrendingDown />} 
                  {Math.abs(item.growth)}%
                </small>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row>
        <Col lg={8}>
          <Card>
            <Card.Header>
              <h5 className="mb-0">Traffic Overview</h5>
            </Card.Header>
            <Card.Body>
              <div className="chart-placeholder">
                <p className="text-center text-muted">Traffic chart would go here</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col lg={4}>
          <Card>
            <Card.Header>
              <h5 className="mb-0">Top Pages</h5>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Page</th>
                    <th>Views</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>/dashboard</td>
                    <td>12,456</td>
                  </tr>
                  <tr>
                    <td>/analytics</td>
                    <td>8,234</td>
                  </tr>
                  <tr>
                    <td>/orders</td>
                    <td>6,789</td>
                  </tr>
                  <tr>
                    <td>/customers</td>
                    <td>4,567</td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Analytics;
